<template>
  <div class="body">
    <div class="nav">
      <img class="back" src="../assets/images/back.png" alt="返回" @click="$router.back()">
      <span class="title"></span>
    </div>
    <div class="form" :style="{marginTop:isIPhoneX()?'260px':'200px'}">
      <div class="form-item">
        <img class="icon" src="../assets/images/phone.png" alt="手机号">
        <input type="number" v-model="mobile" placeholder="授权经销商手机号">
      </div>
      <div class="form-item">
        <img class="icon" src="../assets/images/code.png" alt="验证码">
        <input type="text" v-model="code" placeholder="请输入验证码">
        <button class="code-btn" :disabled="disabled" @click="sendCode">{{ sendTxt }}</button>
      </div>
    </div>
    <div class="auth-box">
      <button class="auth-btn" @click="doLogin">
        登录
      </button>
    </div>
  </div>
</template>

<script>
import {postApi, showToast} from '@/common'

export default {
  name: "List",
  data() {
    return {
      sendTxt: "获取验证码",
      timeout: 60,
      disabled: false,
      mobile: '',
      code: '',
      box_code: ''
    };
  },
  created() {
    this.box_code = this.$route.query.box_code
  },
  methods: {
    isIPhoneX() {
      let u = navigator.userAgent;
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isIOS) {
        return screen.height === 812 && screen.width === 375;
      }
      return false
    },
    sendCode() {
      const that = this;
      console.log("发送验证码：", this.mobile);
      if (this.mobile.trim() === "") {
        showToast("手机号码不能为空");
        return;
      }
      if (!(/^[1][3,4,5,7,8,9][0-9]{9}$/.test(this.mobile))) {
        showToast("手机号码格式不正确");
        return;
      }
      this.disabled = true;
      const sendInterval = setInterval(function () {
        if (that.timeout > 0) {
          that.sendTxt = that.timeout + "秒后重发";
          that.timeout--;
        } else {
          clearInterval(sendInterval);
          that.sendTxt = "获取验证码";
          that.timeout = 60;
          that.disabled = false;
        }
      }, 1000);
      postApi(this.apiBase + '/api/fwm/getsend', {
        mobile: this.mobile,
      }, function (data) {
        console.log("验证码结果：", data);
        if (data.code === 0) {
          showToast('发送成功');
        } else {
          showToast(data.msg);
        }
      })
    },
    doLogin() {
      const that = this
      console.log("点击登录：", this.mobile, this.code);
      if (this.mobile.trim() === "") {
        showToast("手机号码不能为空");
        return;
      }
      if (this.code.trim() === "") {
        showToast("验证码不能为空");
        return;
      }
      postApi(this.apiBase + '/api/fwm/login', {
        mobile: this.mobile,
        code: this.code,
      }, function (data) {
        console.log("登录结果：", data);
        if (data.code === 0) {
          localStorage.setItem('box_code_member_info', JSON.stringify(data.data));
          //有效期为1个小时
          var dateTime = new Date();
          dateTime = dateTime.setHours(dateTime.getHours() + 1);
          dateTime = new Date(dateTime);
          localStorage.setItem('box_code_member_expireat', dateTime.getTime());
          showToast('登录成功', function () {
            that.$router.push({
              path: '/activate',
              query: {
                box_code: that.box_code
              }
            })
          });
        } else {
          showToast(data.msg);
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.body {
  height: 100%;

  .form {
    padding: 0 52px;
    margin-top: 200px;

    .form-item {
      display: flex;
      align-items: center;
      height: 40px;
      border: 1px solid #2979DC;
      border-radius: 5px;
      margin-top: 30px;
      background: #ffffff;

      .icon {
        width: 20px;
        height: 20px;
        margin: 0 10px;
      }

      input {
        flex: 1;
        border: none;
        font-size: 16px;
      }

      .code-btn {
        position: absolute;
        right: 60px;
        background: #2979DC;
        font-weight: bold;
        font-size: 12px;
        border: none;
        color: #ffffff;
        border-radius: 5px;
        height: 25px;
        width: 86px;
      }
    }
  }

  .auth-box {
    display: flex;
    align-items: center;

    .auth-btn {
      width: calc(100% - 104px);
      margin: 0 auto;
      margin-top: 50px;
      height: 40px;
      background: #2979DC;
      font-weight: bold;
      font-size: 16px;
      border: none;
      color: #ffffff;
      border-radius: 5px;
    }
  }
}
</style>
